import React from 'react';
import { CheckCircle2, Clock, AlertTriangle } from 'lucide-react';

interface ClientFinancialStatusProps {
  status: string; // 'Em dia' | 'vence amanhã' | 'em aberto' | 'atrasado'
}

export default function ClientFinancialStatus({ status }: ClientFinancialStatusProps) {
  const isOk = status.toLowerCase().includes('em dia') || status.toLowerCase().includes('pago');
  const isWarning = status.toLowerCase().includes('vence') || status.toLowerCase().includes('amanhã');
  const isDanger = status.toLowerCase().includes('aberto') || status.toLowerCase().includes('atrasado') || status.toLowerCase().includes('vencid');

  let textClass = 'text-emerald-700 font-bold';
  let icon = <CheckCircle2 size={13} className="text-emerald-500" />;
  let containerBg = 'bg-emerald-50/40 border border-emerald-100/50';

  if (isWarning) {
    textClass = 'text-amber-700 font-bold';
    icon = <Clock size={13} className="text-amber-500" />;
    containerBg = 'bg-amber-50/40 border border-amber-100/50';
  } else if (isDanger) {
    textClass = 'text-rose-700 font-bold';
    icon = <AlertTriangle size={13} className="text-rose-500" />;
    containerBg = 'bg-rose-50/40 border border-rose-100/50';
  }

  return (
    <div className={`inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-xl text-xs ${containerBg}`}>
      {icon}
      <span className={textClass}>{status}</span>
    </div>
  );
}
